const getPhoneE164 = async (phoneCode?: string, phone?: string) => {
  const phoneDigits = String(phone || "").replace(/\D/g, "");
  const dialCodeDigits = String(phoneCode || "").replace(/\D/g, "");

  if (!phoneDigits || !dialCodeDigits) return undefined;

  const candidates = [];
  if (String(phone).trim().startsWith("+")) {
    candidates.push(`+${phoneDigits}`);
  } else {
    if (phoneDigits.startsWith(dialCodeDigits)) candidates.push(`+${phoneDigits}`);
    candidates.push(`+${dialCodeDigits}${phoneDigits}`);
    if (phoneDigits.startsWith("0")) {
      candidates.push(`+${dialCodeDigits}${phoneDigits.slice(1)}`);
    }
  }

  try {
    const { parsePhoneNumberFromString } = await import("libphonenumber-js/max");

    for (const candidate of [...new Set(candidates)]) {
      const parsedPhone = parsePhoneNumberFromString(candidate);
      if (parsedPhone?.isValid()) return parsedPhone.number;
    }
  } catch {
    return undefined;
  }

  return undefined;
};

export default getPhoneE164;
